<div class="dash-card-tpl">
    <div class="dash-card-tpl-header"
         *ngIf="header">
        <ng-content select="[dash-card-header]"></ng-content>
    </div>
    <div class="dash-card-tpl-body">
        <ng-content select="[dash-card-body]"></ng-content>
    </div>
    <div class="dash-card-tpl-footer"
         *ngIf="footer">
        <ng-content select="[dash-card-footer]"></ng-content>
    </div>
</div>
